<template>
    <div class="allchain">
        <leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" docutitle="全部产业图谱"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>

            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <span class="title current">项目评估</span>
                    </div>
                </div>
                <div class="whitebox p-4">
                    <div class="boxcontent">
                        <addProject></addProject>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import addProject from "@/components/detail/inc/addProject.vue";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'allchain',
    components: { addProject },
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            title: "项目评估",
            curWebsite: this.$api.getWebsiteType(),
            userdata: {},
            yj_mkcode: 'E-XMPG',
            yj_itemcode: 'E-XMPG',
        }
    },
    watch: {
    },
    created() {
    },
    mounted() { },
    methods: {

    },
}
</script>

<style></style>